moment = require("moment")
_ = require("lodash")

HistoryCtrl = ($scope, $location, DashboardService) ->
  $scope.histories = []
  $scope.isLoading = true

  processData = (data) ->
    data.map (item) ->
      _.merge {}, item,
        course_analysis: {
          best_score: item.course_analysis.best_score || "-"
          avg_total_shot: item.course_analysis.avg_total_shot || "-"
        }
        play_date: moment(item.play_date).format("YYYY/MM/DD")
        rat_par_on: item.rat_par_on * 100
        rat_fairway_center: item.rat_fairway_center * 100
        rat_bogey_on: item.rat_bogey_on * 100

  callMyAnalysis = (params = {}) ->
    $scope.isLoading = true
    DashboardService.getHistories(params)
      .then (res) ->
        $scope.histories = processData(res.score_cards)
      .finally ->
        $scope.isLoading = false
        $scope.$emit "historiesLoaded.gnp.dashboard", $scope.histories.length > 0

  createMyAnalysisParams = ->
    from: $scope.startDate
    to: $scope.endDate
    round_type: $scope.roundType

  $scope.$parent.$on "periodSelected.gnp.dashboard", (event, startDate, endDate, roundType) ->
    $scope.startDate = startDate?.clone()
    $scope.endDate = endDate?.clone()
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

  $scope.$parent.$on "roundTypeUpdated.gnp.dashboard", (event, roundType) ->
    $scope.roundType = roundType
    params = createMyAnalysisParams()
    callMyAnalysis(params)

  $scope.classForRoundIcons = (history) ->
    switch history.round_type
      when 1.5 then 'icons-extra9'
      when 0.5 then 'icons-half-nine'
      else ''

  $scope.navigateToHistory = ->
    $location.path("/history")

  $scope.showScoreCardDetail = (id) ->
    $location.path('/round-detail/' + id)

  prepareParams = (options) ->
    _.pickBy
      from: (options.from.format("YYYY-MM-DD") if options.from)
      to: (options.to.format("YYYY-MM-DD") if options.to)
      round_type: options.round_type?.join(',')
    , (v) -> v != null && v != undefined


HistoryCtrl.$inject = [
  '$scope'
  '$location'
  'DashboardService'
]

module.exports = HistoryCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/history/history-controller.coffee